import { render, staticRenderFns } from "./personals.vue?vue&type=template&id=27a8393e&scoped=true&"
import script from "./personals.vue?vue&type=script&lang=js&"
export * from "./personals.vue?vue&type=script&lang=js&"
import style0 from "./personals.vue?vue&type=style&index=0&id=27a8393e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a8393e",
  null
  
)

export default component.exports